import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ContentContainer,
  ModalTitle,
  ModalText,
  ButtonsContainer,
} from "../ApproveConfirmation/ApproveConfirmationModal.styled";
import { colors } from "../../../theme/colors";

interface UpdateStatusConfirmationModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const UpdateStatusConfirmationModalContent: React.FC<
  UpdateStatusConfirmationModalProps
> = ({ onCancel, onConfirm, isLoading }) => {
  const { t } = useTranslation();

  return (
    <ContentContainer>
      <ModalTitle>{t("updateStatusConfirmation.title")}</ModalTitle>
      <ModalText>{t("updateStatusConfirmation.message")}</ModalText>
      <ButtonsContainer>
        <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
          {t("common.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isLoading}
          sx={{
            backgroundColor: colors.amber.main,
            "&:hover": {
              backgroundColor: colors.amber.dark,
            },
          }}
        >
          {isLoading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            t("updateStatusConfirmation.saveButton")
          )}
        </Button>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default UpdateStatusConfirmationModalContent;
